import { useCallback, useEffect, useRef } from 'react';
import { useAtomValue } from 'jotai';
import type { FlatListProps } from 'react-native';
import { bridge, isNotNil } from 'shared/src/utils';
import { AdAction } from 'shared/src/utils/eventLogger/adLogger/types';
import {
  rankingFilterAtom,
  type RankingFilterState,
} from '../states/rankingFilter.atom';
import { getGoodsAnalytics } from './getGoodsAnalytics';
import type { RankingGoodsCardItem } from '../utils/convertRankingGoodsItemToGoodsData';

export const useLogDisplayGoods = (params: {
  listId: string | undefined;
  listParams: string | undefined;
}) => {
  const filter = useAtomValue(rankingFilterAtom);
  const loggedRef = useRef<Set<number>>(new Set());

  // 필터가 바뀌면 리스트가 새로 로드되므로 중복 방지 Set 초기화
  useEffect(() => {
    loggedRef.current.clear();
  }, [filter]);

  // FlatList는 onViewableItemsChanged를 mount 시점에만 고정하므로
  // 콜백 자체를 안정화하고 최신값은 ref로 읽어 참조
  const latestRef = useRef<{
    filter: RankingFilterState;
    params: { listId: string | undefined; listParams: string | undefined };
  }>({ filter, params });
  latestRef.current = { filter, params };

  return useCallback<
    NonNullable<FlatListProps<RankingGoodsCardItem>['onViewableItemsChanged']>
  >(({ viewableItems }) => {
    const { filter, params } = latestRef.current;
    viewableItems.forEach(({ index, isViewable, item }) => {
      if (!isViewable || index == null) return;
      if (loggedRef.current.has(item.item.sno)) return;
      loggedRef.current.add(item.item.sno);

      bridge.logAnalyticsEvent({
        name: 'DISPLAY_GOODS',
        analytics: getGoodsAnalytics(
          item,
          index,
          filter,
          params,
          'DISPLAY_GOODS',
        ),
      });
      if (isNotNil(item.item.ad)) {
        bridge.logAdEvent({ action: AdAction.DISPLAY, ad: item.item.ad });
      }
    });
  }, []);
};
